import { keyframes } from '@emotion/react'

export const fade = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`

export const bgGradientAngle = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`

export const bgGradientSize = keyframes`
  0% {
    background-size: 180% 180%;
  }
  33% {
    background-size: 200% 200%;
  }
  66% {
    background-size: 150% 150%;
  }
  100% {
    background-size: 180% 180%;
  }
`
export const carouselProgressBar = keyframes`
  100% {
    transform: scaleX(1);
  }
`
